import { ServiceHandler } from '../../utils/api.utils';
import type {
  FnolAcceptRequest,
  FnolAnswers,
  FnolClaimPolicies,
  FnolDetailsForm,
  FnolEligiblePolicy,
  FnolForm,
  FnolSubmitResponse,
} from '../../console/customers/claims/fnol/fnol.types';

export interface FnolSubmitBody {
  readonly policyId: string;
  readonly situationId: string;
  readonly confirmedNewIncident: boolean;
  readonly answers: FnolAnswers;
}

export interface FnolAddDetailsBody {
  readonly answers?: FnolAnswers;
  readonly note?: string;
  readonly documentIds?: string[];
}

/** The signed-in policyholder's policies a claim can be reported on online. Empty = no Open new claim action. */
export const getFnolEligiblePolicies = ServiceHandler<
  unknown,
  FnolEligiblePolicy[]
>({
  url: '/api/claimsmgmt/v1/fnol/policies',
});

/** The form for one of the signed-in policyholder's policies: catalog, situations and existingClaims (duplicate guard). */
export const getFnolForm = ServiceHandler<unknown, FnolForm>({
  url: '/api/claimsmgmt/v1/fnol/policies/:policyId/form',
});

export const submitFnolClaim = ServiceHandler<
  FnolSubmitBody,
  FnolSubmitResponse
>({
  url: '/api/claimsmgmt/v1/fnol',
  method: 'POST',
});

/** The fields the policyholder can still add to one of their own claims, prefilled with current answers. */
export const getClaimDetailsForm = ServiceHandler<unknown, FnolDetailsForm>({
  url: '/api/claimsmgmt/v1/fnol/claims/:claimId/details-form',
});

export const addClaimDetails = ServiceHandler<FnolAddDetailsBody, void>({
  url: '/api/claimsmgmt/v1/fnol/claims/:claimId/details',
  method: 'POST',
});

/** Claim Ops: the policy an FNOL claim sits on and the term before it, which accept can move it to. */
export const getFnolClaimPolicies = ServiceHandler<unknown, FnolClaimPolicies>({
  url: '/api/claimsmgmt/v1/fnol/claims/:claimId/policies',
});

export const acceptFnolClaim = ServiceHandler<FnolAcceptRequest, void>({
  url: '/api/claimsmgmt/v1/fnol/claims/:claimId/accept',
  method: 'PUT',
});
